import { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import { CardContent, FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialSelect from "../../../../components/MasterSelect";
import { generateYearOptions } from "../../../Utils/GenerateYearOptions";
import { fetchData } from "../../../../services";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const MotorVariantForm = ({ editVariantData, onsubmit }) => {

  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [variantData, setVariantData] = useState({
    // model information
    name: "",
    launchYear: "",
    vehicleCategory: null,
    iplVehicleCategoryId: "",
    iplVehicleCategoryName: "",
    motorModel: null,
    motorModelId: "",
    motorModelName: "",
    fuelType: "",
    engineCapacity: "",
    seatCapacity: "",
    carryingCapacity: "",
    iibCode: "",
    bodyType: "",
    bodyStyle: "",
    wheels: "",
    isActive: true,

    // model information status
    nameStatus: "unchecked",
    launchYearStatus: "unchecked",
    vehicleCategoryStatus: "unchecked",
    motorModelStatus: "unchecked",
    fuelTypeStatus: "unchecked",
    engineCapacityStatus: "unchecked",
    seatCapacityStatus: "unchecked",
    carryingCapacityStatus: "unchecked",
    bodyTypeStatus: "unchecked",
    bodyStyleStatus: "unchecked",
    wheelsStatus: "unchecked",
  });
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [motorModelOptions, setMotorModelOptions] = useState([]);
  const [bodyStyleOptions, setBodyStyleOptions] = useState([]);
  const [bodyTypeOptions, setBodyTypeOptions] = useState([]);
  const [fuelTypeOptions, setFuelTypeOptions] = useState([]);
  const launchYearOptions = generateYearOptions(new Date().getFullYear(), 1900);

  useEffect(() => {    
    const fetchAllDropdowns = async () => {
      setCircleLoading(true);

      try {
        const [
          categoryRes,
          modelRes,
          bodyTypeRes,
          bodyStyleRes,
          fuelTypeRes,
        ] = await Promise.all([
          fetchData(
            `/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.motorCategory}`
          ),
          fetchData(
            `/reference/motor/mmv/models?dropdown=true`
          ),
          fetchData(
            `/reference/motor/body-type?dropdown=true&isActive=true`
          ),
          fetchData(
            `/reference/motor/bodystyles?dropdown=true`
          ),
          fetchData(
            `/reference/motor/key-value-store?dropdown=true&code=${DropDownConfig?.motorFuelType}`
          ),
        ]);

        // Category
        if (categoryRes?.success) {
          setCategoryOptions(
            categoryRes.data?.items?.map(item => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        }

        // Model
        if (modelRes?.success) {
          setMotorModelOptions(
            modelRes.data?.items?.map(item => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        }

        // Body Type
        if (bodyTypeRes?.success) {
          setBodyTypeOptions(
            bodyTypeRes.data?.items?.map(item => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        }

        // Body Style
        if (bodyStyleRes?.success) {
          setBodyStyleOptions(
            bodyStyleRes.data?.items?.map(item => ({
              value: item.id,
              label: item.name,
            })) || []
          );
        }

        // Fuel Type
        if (fuelTypeRes?.success) {
          setFuelTypeOptions(
            fuelTypeRes.data?.items?.map(item => ({
              value: item.id,
              label: item.keyName,
            })) || []
          );
        }

      } catch (error) {
        console.error("Error fetching dropdowns:", error);
        showSnackbar("Error fetching dropdown data", "warning");
      } finally {
        setCircleLoading(false);
      }
    };
    fetchAllDropdowns();
  }, []);

  useEffect(() => {
    if (editVariantData) {
      setVariantData(editVariantData);
    }
  }, [editVariantData]);

  const handleVariantDataChange = (event, selectEvent) => {
    let variantState = { ...variantData };

    const changeAllowed = true;

    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "vehicleCategory":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";

              variantState["iplVehicleCategoryId"] = event?.value;
              variantState["iplVehicleCategoryName"] = event?.label;
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "launchYear":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "motorModel":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";

              variantState["motorModelId"] = event?.value;
              variantState["motorModelName"] = event?.label;
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "fuelType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "bodyType":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "bodyStyle":
          {
            const lengthRegex = new RegExp("^[A-Za-z0-9]");
            if (lengthRegex.test(event?.label) === true) {
              variantState[selectEvent.name + "Status"] =
                event?.label === undefined ? "unchecked" : "success";
            } else {
              variantState[selectEvent.name + "Status"] =
                selectEvent.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      variantState[selectEvent.name] = event;
    } else if (event) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,40})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "engineCapacity":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "seatCapacity":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,5})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "carryingCapacity":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "wheels":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,2})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "iibCode":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,10})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              variantState[event.target.name + "Status"] = "success";
            } else {
              variantState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        variantState[event.target.name] = event.target.value;
      }
    }
    setVariantData(variantState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      variantData.nameStatus === "success" &&
      variantData.vehicleCategoryStatus === "success" &&
      variantData.motorModelStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(variantData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "65vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Variant Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. Variant Name"
                value={variantData.name}
                onChange={handleVariantDataChange}
                error={variantData.nameStatus === "error" ? true : false}
                success={variantData.nameStatus === "success" ? true : false}
              />
              {variantData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 40 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Launch Year*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="launchYear"
                value={variantData.launchYear}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={launchYearOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={variantData.launchYearStatus === "error" ? true : false}
                success={
                  variantData.launchYearStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Category*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="vehicleCategory"
                value={variantData.vehicleCategory}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={categoryOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={
                  variantData.vehicleCategoryStatus === "error" ? true : false
                }
                success={
                  variantData.vehicleCategoryStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Motor Model*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="motorModel"
                value={variantData.motorModel}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={motorModelOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={variantData.motorModelStatus === "error" ? true : false}
                success={
                  variantData.motorModelStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Fuel Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="fuelType"
                value={variantData.fuelType}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={fuelTypeOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={variantData.fuelTypeStatus === "error" ? true : false}
                success={
                  variantData.fuelTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Engine Capacity (cc)*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="engineCapacity"
                placeholder="eg. 1500"
                value={variantData.engineCapacity}
                onChange={handleVariantDataChange}
                error={
                  variantData.engineCapacityStatus === "error" ? true : false
                }
                success={
                  variantData.engineCapacityStatus === "success" ? true : false
                }
              />
              {variantData.engineCapacityStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Engine Capacity should be maximum 20 characters long and can
                    contain only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Seat Capacity*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="seatCapacity"
                placeholder="eg. 6"
                value={variantData.seatCapacity}
                onChange={handleVariantDataChange}
                error={
                  variantData.seatCapacityStatus === "error" ? true : false
                }
                success={
                  variantData.seatCapacityStatus === "success" ? true : false
                }
              />
              {variantData.seatCapacityStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Seat Capacity should be maximum 5 digits long and can
                    contain only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Carrying Capacity (kg)*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="carryingCapacity"
                placeholder="eg. 5000"
                value={variantData.carryingCapacity}
                onChange={handleVariantDataChange}
                error={
                  variantData.carryingCapacityStatus === "error" ? true : false
                }
                success={
                  variantData.carryingCapacityStatus === "success"
                    ? true
                    : false
                }
              />
              {variantData.carryingCapacityStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Carrying Capacity should be maximum 20 digits long and can
                    contain only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Body Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="bodyType"
                value={variantData.bodyType}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={bodyTypeOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={variantData.bodyTypeStatus === "error" ? true : false}
                success={
                  variantData.bodyTypeStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Body Style*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="bodyStyle"
                value={variantData.bodyStyle}
                customStyles={{ optionPadding: 20 }}
                onChange={handleVariantDataChange} //selectedValue, event
                options={bodyStyleOptions?.map((value) => {
                  return {
                    value: value.value,
                    label: value.label,
                  };
                })}
                error={variantData.bodyStyleStatus === "error" ? true : false}
                success={
                  variantData.bodyStyleStatus === "success" ? true : false
                }
                isClearable
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Wheels*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="wheels"
                placeholder="eg. 4"
                type="number"
                value={variantData.wheels}
                onChange={handleVariantDataChange}
                error={variantData.wheelsStatus === "error" ? true : false}
                success={variantData.wheelsStatus === "success" ? true : false}
              />
              {variantData.wheelsStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Wheels should be maximum 2 digits long and can contain only
                    numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  IIB Code*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="iibCode"
                placeholder="eg. 4"
                type="number"
                value={variantData.iibCode}
                onChange={handleVariantDataChange}
                error={variantData.iibCodeStatus === "error" ? true : false}
                success={variantData.iibCodeStatus === "success" ? true : false}
              />
              {variantData.iibCodeStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    IIB Code should be maximum 10 digits long and can contain
                    only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Actve
                </MaterialTypography>
              <MaterialBox >
                <FormControlLabel
                  control={
                    <Switch
                      checked={variantData.isActive}
                      onChange={(e) =>
                        handleVariantDataChange({
                          target: {
                            name: "isActive",
                            value: e.target.checked,
                          },
                        })
                      }
                      color="primary"
                    />
                  }
                  label={
                    <MaterialTypography variant="caption" fontWeight="bold">
                      {variantData.isActive ? "Active" : "Inactive"}
                    </MaterialTypography>
                  }
                  sx={{ marginLeft: 0 }}
                />
              </MaterialBox>
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            window.history.back();
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
